import type { InjectionKey, Component } from "vue";
import type { DxDataGridTypes } from "devextreme-vue/data-grid";
import type { FacturaDetailModel } from "@api/api";

/** Referencias a las rejillas de desglose definidas en cada portal (tramites → rappels). */
export interface FacturaDesgloseGrids {
  TramitesGrid: Component;
  RappelsGrid: Component;
}

export const facturaDesgloseGridsKey: InjectionKey<FacturaDesgloseGrids> = Symbol("facturaDesgloseGrids");

/**
 * Replica la forma `template-data` del master-detail de facturas para cargar tramites/rappels
 * cuando el contexto es el modal de detalle (solo disponemos de {@link FacturaDetailModel}).
 */
export function buildFacturaDesgloseTemplateData(idFactura: string, model: FacturaDetailModel): DxDataGridTypes.MasterDetailTemplateData {
  const codigoEfectivo = model.Identificador != null && model.Identificador !== "" ? model.Identificador : model.IdentificadorBorrador;
  
  return {
    key: idFactura,
    data: {
      ...model,
      CodigoIdentificador: codigoEfectivo,
    },
  } as DxDataGridTypes.MasterDetailTemplateData;
}
